import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListView } from '../core/ListViewProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { useClienteAtual } from '../../empresasCliente-list/core/useClienteAtual'
import { ExameColumns } from './columns/_columns'
import { ExameAsoView } from '../core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const ExameClienteTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { selected } = useListView()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const cliente = useClienteAtual()
  const { t } = useT()

  const columns = useMemo(() => ExameColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={`Nenhum exame encontrado para “${filters.exame.trim()}”`}
      description='Revise o termo digitado.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title={
        cliente?.nome ? `Nenhum exame cadastrado em ${cliente.nome}` : 'Nenhum exame cadastrado'
      }
      description='Use “Adicionar” para cadastrar o primeiro exame por setor e cargo.'
    />
  )

  return (
    <CustomTable<ExameAsoView>
      id='kt_table_exames_cliente'
      ariaLabel='Exames'
      itemLabel={{ singular: 'exame', plural: 'exames' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      isRowSelected={(row) => selected.includes(row.id)}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
